<template>
    <div id="products-page" v-if="loged">
        <div class="page-header">
            <div class="user-info">
                <img class="v-m" :src="avatar" />
                <span class="v-m fb fs-0-8 segoe username">{{ username }}</span>
                <div class="user-id-cont">
                    <div class="user-id">
                        <span class="v-m fb fs-1 segpe userID">ID:{{ userID }}</span>
                        <img class="v-m btn" :src="_global.assetsRoot + '/tutorial_button.png'"
                            @click="showUserIDTutorialPopup" />
                    </div>
                    <div class="user-id-tip">
                        <span class="fs-12px segpe">{{ $t("message.userIDTip") }}</span>
                    </div>
                </div>
            </div>
            <div class="header-logo t-c v-m">
                <img class="v-m" :src="_global.assetsRoot + '/common/header_logo.png'" />
            </div>
            <div class="user-info-id" v-show="!isMobile">
                <div class="user-info-text">
                    <span class="user-id beba">USER ID:{{ userID }}</span>
                    <span class="check-it beba">{{ $t("message.footerCheckOnDrBingo") }}</span>
                </div>
            </div>
            <div class="user-coins t-c v-m">
                <div class="coins v-m t-l">
                    <img ref="coinsIcon" class="coins-icon" :src="_global.assetsRoot + '/common/header_icon_coins​​​.png'" />
                    <span class="fs-1 segoe v-b">{{ airdropCoins || coins }}</span>
                </div>
            </div>
            <div class="user-dinero t-c v-m">
                <div class="dineros v-m t-l">
                    <img ref="chipsIcon" class="dinero-icon" :src="_global.assetsRoot + '/common/header_icon_dinero.png'" />
                    <span class="fs-1 segoe v-b">{{ bonusChips || chips }}</span>
                </div>
            </div>
            <!-- lucky-coins 入口已下线，但保留该占位块以维持页头 flex 三等分的原始宽度比例，
                 避免 coins/dinero 的背景框因容器变宽而与图标错位（跑出框外） -->
            <div class="user-lucky-coins t-c v-m user-lucky-coins--placeholder"></div>
            <div class="header-menu t-c v-m" @click.stop="toggleMenuLogout">
                <img class="v-m" :src="_global.assetsRoot + '/common/header_menu.png'" />
            </div>
            <div class="logout t-r">
                <div class="btn logout-btn t-c v-m" @click.stop="showLogoutTip">
                    <img class="v-m" :src="_global.assetsRoot + '/logout_icon.png'" />
                    <span class="fs-0-8 fb v-m segoe">{{ $t("message.logout") }}</span>
                </div>
            </div>
        </div>
        <div class="installer-strip" v-show="showInstallerStrip && isMobile && !showPrizePage">
            <div class="installer-left">
                <img class="installer-close btn" :src="_global.assetsRoot + '/common/close_install.png'" @click.stop="closeInstallerStrip" />
                <img class="installer-logo" :src="_global.assetsRoot + '/common/drbingo_logo.png'" />
                <div class="installer-text">
                    <span class="installer-text-line segoe fb">{{ $t("message.openAppMegaWinTitle") }}</span>
                    <span class="installer-text-line segoe fb">{{ $t("message.openAppMegaWinSubtitle") }}</span>
                    <span class="installer-text-line segoe fb">{{ $t("message.openAppMegaWinCta") }}</span>
                </div>
            </div>
            <div class="installer-right">
                <img
                    v-if="showMenuLogout"
                    class="installer-logout btn"
                    :src="_global.assetsRoot + `/common/header_logout_${_i18n.locale}.png`"
                    @click.stop="showLogoutTip"
                />
                <img
                    v-else
                    class="installer-install btn"
                    :src="_global.assetsRoot + `/common/btn_install_${_i18n.locale}.png`"
                    @click="showOpenAppPopup"
                />
            </div>
        </div>
        <div class="vip-section" v-show="!showPrizePage && (!isMobile || !showInstallerStrip)">
            <div class="info-icon" @click.stop="showInfoPopup">
                <img class="v-m" :src="_global.assetsRoot + '/common/header_icon_info​​​.png'" />
            </div>
            <div class="vip-bar">
                <img class="vip-level-icon left" :src="vipLeftIconSrc" />
                <img class="vip-bar-base v-m" :src="_global.assetsRoot + '/common/viplevel_grogress.png'" />
                <img class="vip-bar-loading v-m" :style="vipBarLoadingStyle" :src="_global.assetsRoot + '/common/viplevel_grogress_loading.png'" />
                <span class="vip-bar-text segoe fb">{{ vipBarText }}</span>
                <img v-if="vipLevelValue < 7" class="vip-level-icon right" :src="vipRightIconSrc" />
            </div>
            <div class="vip-bp" v-show="!showMenuLogout">
                <img class="v-m" :src="_global.assetsRoot + '/common/icon_payment_bp.png'" />
                <img class="v-m" :src="vipBpNumberSrc" />
                <span class="vip-bp-text segoe fb">{{vip_bp}}</span>
            </div>
            <div class="vip-logout" v-show="showMenuLogout" @click.stop="showLogoutTip">
                <img class="v-m" :src="_global.assetsRoot + `/common/header_logout_${_i18n.locale}.png`" />
            </div>
        </div>
        <div class="page-content">
            <div class="content" v-if="!showPrizePage">
                <div class="banners" v-if="products && products.banners && products.banners.length > 0">
                    <swiper :options="swiperOptions" ref="swiperObj">
                        <swiper-slide v-for="(banner, i) in products.banners" :key="i">
                            <img :src="banner.src" />
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="title t-c v-m" v-if="products.bundles.length > 0">
                    <img class="arrow reverse v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                    <img class="title-icon v-m promition"
                        :src="_global.assetsRoot + `/promotion_${_i18n.locale}.png`" />
                    <img class="arrow v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                </div>
                <bundles :data="products.bundles" :extra="loyaltyExtra" @buy="buy" />
                <!--DynamicPo v-for="(p, i) in poList" :key="i" :ref="p.type" :data="p" :poIndex=i :extra="loyaltyExtra"
                    :regularReward=regularReward @buy="buy" /-->
                <DynamicPoTemplate
                    v-for="(p, i) in dynamicPoTemplates"
                    :ref="p.type"
                    :key="getPoTemplateKey(p, i)"
                    :layout-url="p.layoutUrl"
                    :data="p"
                    :locale="_i18n.locale"
                    :extra="loyaltyExtra"
                    :po-index="i"
                    :regular-reward="regularReward"
                    @buy="buy"
                />
                <div class="title t-c v-m" v-if="products.coins.length > 0">
                    <!--img class="arrow reverse v-m" :src="_global.assetsRoot + '/pic_title.png'" /-->
                    <img class="title-icon v-m" :src="_global.assetsRoot + `/common/coins_icon/web_phone_coins_title_${_i18n.locale}.png`" />
                    <!--img class="arrow v-m" :src="_global.assetsRoot + '/pic_title.png'" /-->
                </div>
                <coins :data="products.coins" :extra="loyaltyExtra" @buy="buy" />
                <div class="title t-c v-m" v-if="products.chips.length > 0">
                    <!--img class="arrow reverse v-m" :src="_global.assetsRoot + '/pic_title.png'" /-->
                    <img class="title-icon v-m" :src="_global.assetsRoot + `/common/dineros_icon/web_phone_dinero_title_${_i18n.locale}.png`" />
                    <!--img class="arrow v-m" :src="_global.assetsRoot + '/pic_title.png'" /-->
                </div>
                <chips :data="products.chips" :extra="loyaltyExtra" @buy="buy" />
            </div>

            <div class="prize-content" v-if="showPrizePage">
                <prizes :data="clawProducts" @back="closePrizePage" @updateCoins="updateCoins" @showFooter="showFooter" />
            </div>
            <div v-if="!isMobile && !showPrizePage" class="page-footer">
                <div class="secure-payment">
                    <img class="v-m btn" :src="_global.assetsRoot + '/desktop/web_pc_footer_icon_safe.png'"/>
                    <div class="secure-payment-text">
                        <span class="secure-100 beba">{{ $t("message.footerSecure") }}</span>
                        <span class="pix-payment beba">{{ $t("message.footerPixPayment") }}</span>
                    </div>
                </div>
                <div class="footer-help">
                    <img class="v-m btn" :src="_global.assetsRoot + '/desktop/web_pc_footer_icon_service.png'"/>
                    <div class="footer-help-text">
                        <span class="need-help beba">{{ $t("message.footerNeedHelp") }}</span>
                        <span class="support-email beba">SUPPORT@DOUTORBINGO.COM</span>
                    </div>
                </div>
                <div class="user-info">
                    <div class="user-info-text">
                        <span class="user-id beba">USER ID:{{ userID }}</span>
                        <span class="check-it beba">{{ $t("message.footerCheckOnDrBingo") }}</span>
                    </div>
                </div>
                <!--div class="user-info">
                    <div class="user-id-cont">
                        <div class="user-id">
                            <img class="v-m btn" :src="_global.assetsRoot + '/tutorial_button.png'"
                                @click="showUserIDTutorialPopup" />
                            <span class="v-m fb fs-1-4 segpe userID">ID:{{ userID }}</span>
                        </div>
                        <div class="user-id-tip">
                            <span class="fs-1 segpe">{{ $t("message.userIDTip") }}</span>
                        </div>
                    </div>
                </div>
                <div class="logout">
                    <div class="btn logout-btn rel-center t-c v-m" @click.stop="showLogoutTip">
                        <img class="v-m" :src="_global.assetsRoot + '/logout_icon.png'" />
                        <span class="fs-1-5 fb v-m">{{ $t("message.logout") }}</span>
                    </div>
                </div-->
            </div>
        </div>

        <div v-if="!footerVisible && isMobile" class="page-footer">
            <div class="secure-payment">
                <img class="v-m btn" :src="_global.assetsRoot + '/common/footer_icon_safe.png'"/>
                <div class="secure-payment-text">
                    <span class="secure-100 beba">{{ $t("message.footerSecure") }}</span>
                    <span class="pix-payment beba">{{ $t("message.footerPixPayment") }}</span>
                </div>
            </div>
            <div class="footer-help">
                <img class="v-m btn" :src="_global.assetsRoot + '/common/footer_icon_service.png'"/>
                <div class="footer-help-text">
                    <span class="need-help beba">{{ $t("message.footerNeedHelp") }}</span>
                    <span class="support-email beba">SUPPORT@DOUTORBINGO.COM</span>
                </div>
            </div>
            <div class="user-info">
                <div class="user-info-text">
                    <span class="user-id beba">USER ID:{{ userID }}</span>
                    <span class="check-it beba">{{ $t("message.footerCheckOnDrBingo") }}</span>
                </div>
            </div>
            <!--div class="user-info">
                <div class="user-id-cont">
                    <div class="user-id">
                        <img class="v-m btn" :src="_global.assetsRoot + '/tutorial_button.png'"
                            @click="showUserIDTutorialPopup" />
                        <span class="v-m fb fs-1-4 segpe userID">ID:{{ userID }}</span>
                    </div>
                    <div class="user-id-tip">
                        <span class="fs-1 segpe">{{ $t("message.userIDTip") }}</span>
                    </div>
                </div>
            </div>
            <div class="logout">
                <div class="btn logout-btn rel-center t-c v-m" @click.stop="showLogoutTip">
                    <img class="v-m" :src="_global.assetsRoot + '/logout_icon.png'" />
                    <span class="fs-1-5 fb v-m">{{ $t("message.logout") }}</span>
                </div>
            </div-->
        </div>
        
        <Logout ref="logoutPopup" @logout="logout"></Logout>
        <Collect ref="collect" :data="purchase" :to="to" @collect="collect" @tanimation="showTextAnimation"
            @claimFree="claimFreeReward" @collectFree="collectFreeReward" />
        <Payment ref="payment" :paymentId="paymentId" @payment="openPaymentPage" @onhide="onPaymentHide" />
        <Award ref="award" :userID="userID" @airdrop-collected-coins="handleAirdropCoins"
            @open-redeem="showRedeemPopup" />
        <!--OpenApp v-if="appPopup" ref="openApp" :userID="userID" @airdrop-collected-coins="handleAirdropCoins"
            @open-redeem="showRedeemPopup" /-->
        <!--Redeem ref="redeem" /-->
        <OpenApp ref="redeem" />
        <FirstLogin ref="userIDTutorial" />
        <Scratch ref="scratchCard" :userID="userID" @bonus-collected="handleBonusCollection" />
        <Bonus ref="bonusModal" />
        <PaymentFailure ref="paymentFailure" @onclose="onPaymentFailureClose" />
        <Info ref="infoPopup" />
    </div>
</template>

<script>
import Logout from '../components/popup/Logout.vue';
import Collect from '../components/popup/Collect.vue';
import Payment from '../components/popup/Payment.vue';
import DynamicPo from '../components/popup/DynamicPo.vue';
import DynamicPoTemplate from '../components/popup/DynamicPoTemplate.vue';
import FirstLogin from '../components/popup/FirstLogin.vue';
import Info from '../components/popup/Info.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import prizes from '../components/layouts/prizes.vue';
import bundles from '../components/layouts/bundles.vue';
import claw from '../components/layouts/claw.vue';
import coins from '../components/layouts/coins.vue';
import chips from '../components/layouts/chips.vue';
import api from '../network/api.js';
import utils from '../utils/utils.js';
import Award from '../components/popup/Award.vue';
import OpenApp from '../components/popup/OpenApp.vue';
import Scratch from '../components/popup/Scratch.vue';
import Redeem from '../components/popup/Redeem.vue';
import Bonus from '../components/popup/Bonus.vue';
import PaymentFailure from '../components/popup/PaymentFailure.vue';

const INSTALLER_DISMISSED_KEY = 'drbingo_installer_dismissed';
const APP_INSTALLED_HINT_KEY = 'drbingo_app_installed_hint';

export default {
    data() {
        return {
            loged: false,
            user: null,
            animationCoins: 0,
            animationChips: 0,
            animationToken: 0,
            swiperObj: null,
            swiperOptions: {
                loop: true,
                speed: 500,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false
                },
                on: {
                    /*click: function () {
                        window.vthis.wakeupApp && window.vthis.wakeupApp();
                    }*/
                }
            },
            isPending: false,
            products: {},
            loyalty: {},
            vip_store: {},
            paymentId: "",
            purchase: {},
            to: null,
            pendingTimer: null,
            singular: null,
            poList: [],
            poIndex: -1,
            pIndex: -1,
            airdrop: [],
            airdropCoins: null,
            bonusChips: null,
            regularReward: "NOT_CHECKED",
            pageLoad: true,
            showPrizePage: false,
            clawProducts: [],
            footerVisible: true,
            paymentCheckInterval: null,
            paymentTimeoutTimer: null,
            paymentTimeout: 600000,  // 10 minutes timeout
            appPopup: false,
            showMenuLogout: false,
            showInstallerStrip: true,
            pendingFreeProduct: null
        }
    },
    created() {
        if (this._global.user && this._global.products) {
            this.loged = true;
            this.user = this._global.user;
            this.products = this._global.products;
            this.loyalty = this._global.loyalty || {};
            this.vip_store = this._global.vip_store || {};
        }
        if (this._global.airdrop) {
            this.airdrop = this._global.airdrop;
        }
        window.vthis = this;
        this._paymentWindowHandle = null;
        this.swiperOptions.loop = this.products.banners && this.products.banners.length > 1;
        this.poList = this._global.poList || [];
    },
    mounted() {
        this.footerVisible = !this.isMobile;

        if (this.isMobile) {
            const dismissed = localStorage.getItem(INSTALLER_DISMISSED_KEY) === '1';
            const installedHint = localStorage.getItem(APP_INSTALLED_HINT_KEY) === '1';
            this.showInstallerStrip = !(dismissed || installedHint);
        }

        if (this.loged) {
            this._onViewportChange = this.updateAnimationTargets.bind(this);
            window.addEventListener('resize', this._onViewportChange);
            window.addEventListener('orientationchange', this._onViewportChange);

            // To check purchase popup - TEMPORARY: showing all reward types
            /*let purchase = {
                "pendingId": "temp-123",
                "isFree": false,
                "type": "web_po",
                "coins": 5000,
                "chips": 2500,
                "is_wheel": 0,
                "is_black_wheel" : 1,
                //"bp": 5000,
                "golden_token": 50,
                "loyalty_level": 3
            }

            this.purchase = purchase;
            this.updateAnimationTargets();
            this.$refs.collect.show();*/

            if (this.$refs.swiperObj) {
                this.swiperObj = this.$refs.swiperObj.swiper;
                if (!this.products.banners || this.products.banners.length <= 1) this.swiperObj.autoplay.stop();
            }

            if (typeof singularSdk !== "undefined" && typeof SingularConfig !== "undefined") {
                this.singular = new SingularConfig("gamesmart_4611daf8", "2ff18b562cb48740fd92fe3419ab46ac", "com.gamesmartltd.doctorbingo").withCustomUserId(this.userID);
                singularSdk.init(this.singular);
            }

            this.pending(true);

            // TEMPORARY: Mock airdrop data for testing
            /*this.airdrop = [
                {
                    type: 'coins',
                    value: 500
                },
                {
                    type: 'shop_items',
                    item_type: '2',
                    item_star: '3'
                }
            ];
            this._global.airdrop = this.airdrop;*/

            if (this.appPopup && this.$refs.openApp) {
                //this.$refs.openApp.show();
            }
            else if (this._global.extra.bonus_id) {
                if (['expired', 'not_available', 'not_found'].includes(this._global.extra.bonus_status)) {
                    this.$refs.bonusModal.show();
                }
                else {
                    this.$refs.scratchCard.show();
                }
            }
            else if (this.airdrop.length !== 0) {
                this.$refs.award.show();
            }
        }
    },
    beforeDestroy() {
        // Clean up timers and intervals
        if (this.paymentCheckInterval) {
            clearInterval(this.paymentCheckInterval);
        }
        if (this.paymentTimeoutTimer) {
            clearTimeout(this.paymentTimeoutTimer);
        }
        if (this.pendingTimer) {
            clearTimeout(this.pendingTimer);
        }

        if (this._onViewportChange) {
            window.removeEventListener('resize', this._onViewportChange);
            window.removeEventListener('orientationchange', this._onViewportChange);
        }
    },
    computed: {
        userID() { return (this.user && this.user.userID) || null },
        avatar() { return (this.user && this.user.avatar) || (this._global.assetsRoot + '/avatar.png') },
        username() { return (this.user && this.user.username) || this.userID },
        coins() { return utils.fc(this.animationCoins || (this.user && this.user.coins)) || 0 },
        chips() { return utils.fc(this.animationChips || (this.user && this.user.chips)) || 0 },
        golden_token() { return utils.fc(this.animationToken || (this.user && this.user.golden_token)) || 0 },
        vip_bp() {
            return utils.fc(this.user && this.user.vip_bp) || 0
        },
        vipLevelValue() {
            const rawVipLevel = this.user && this.user.vip_level;
            const vipLevel = Number(rawVipLevel);
            return Number.isFinite(vipLevel) ? vipLevel : 1;
        },
        vipLeftIconSrc() {
            const vipLevelIcons = {
                1: 'vip_ic_level_iron.png',
                2: 'vip_ic_level_bronze.png',
                3: 'vip_ic_level_silver.png',
                4: 'vip_ic_level_gold.png',
                5: 'vip_ic_level_platinum.png',
                6: 'vip_ic_level_emerald.png',
                7: 'vip_ic_level_diamond.png'
            };

            if (this.vipLevelValue === 0) {
                return `${this._global.assetsRoot}/common/vip_ic_level_lock.png`;
            }

            return `${this._global.assetsRoot}/common/${vipLevelIcons[this.vipLevelValue] || vipLevelIcons[1]}`;
        },
        vipRightIconSrc() {
            const vipLevelIcons = {
                1: 'vip_ic_level_iron.png',
                2: 'vip_ic_level_bronze.png',
                3: 'vip_ic_level_silver.png',
                4: 'vip_ic_level_gold.png',
                5: 'vip_ic_level_platinum.png',
                6: 'vip_ic_level_emerald.png',
                7: 'vip_ic_level_diamond.png'
            };

            if (this.vipLevelValue === 0) {
                return `${this._global.assetsRoot}/common/vip_ic_level_iron.png`;
            }

            const nextLevelFromApi = Number(this.user && this.user.vip_next_level);
            //console.log(this.user.vip_next_level, nextLevelFromApi);
            const nextLevel = Number.isFinite(nextLevelFromApi) && nextLevelFromApi > 0
                ? Math.min(nextLevelFromApi, 7)
                : Math.min(this.vipLevelValue + 1, 7);
            //console.log("Next Level", nextLevel);
            return `${this._global.assetsRoot}/common/${vipLevelIcons[nextLevel] || vipLevelIcons[7]}`;
        },
        vipBarText() {
            if (this.vipLevelValue === 0) {
                return "0/0";
            }

            if (this.vipLevelValue >= 7) {
                return "1";
            }

            const vipXp = Number(this.user && this.user.vip_level_xp_progress) || 0;
            const vipNextLevelXp = Number(this.user && this.user.vip_level_xp_required) || 0;

            return `${vipXp}/${vipNextLevelXp}`;
        },
        vipBarLoadingStyle() {
            if (this.vipLevelValue === 0) {
                return {
                    clipPath: "inset(0 100% 0 0)"
                };
            }

            if (this.vipLevelValue >= 7) {
                return {
                    clipPath: "inset(0 0 0 0)"
                };
            }

            const vipXp = Number(this.user && this.user.vip_level_xp_progress) || 0;
            const vipNextLevelXp = Number(this.user && this.user.vip_level_xp_required) || 0;
            const progress = vipNextLevelXp > 0 ? Math.min(Math.max((vipXp / vipNextLevelXp) * 100, 0), 100) : 0;

            return {
                clipPath: `inset(0 ${100 - progress}% 0 0)`
            };
        },
        dynamicPoTemplates() {
            const allowedTypes = ["web_po", "web_two_po", "web_three_po", "web_rolling_po"];
            return (this.poList || []).filter((item) => {
                return item && item.layoutUrl && allowedTypes.indexOf(item.type) !== -1;
            });
        },
        isMobile() {
            if (typeof window === 'undefined') return false;
            if (window._global && typeof window._global.isMobile !== 'undefined') return !!window._global.isMobile;
            return window.matchMedia && window.matchMedia('(max-width: 1024px)').matches;
        },
        vipBpNumberSrc() {
            const bpNumberFile = this.isMobile ? 'mobile/web_phone_bp_number.png' : 'desktop/web_pc_bp_number.png';
            return `${this._global.assetsRoot}/${bpNumberFile}`;
        },
        loyaltyExtra() {
            const level = this.vip_store && this.vip_store.vip_level;
            const privileges = this.vip_store && this.vip_store.privileges;
            const profile = level && privileges ? privileges[level] : null;
            return {
                coins: profile ? Number(profile.purchase_coins_x) : 0,
                chips: profile ? Number(profile.purchase_chips_x) : 0
            }
        }
    },
    methods: {
        updateAnimationTargets() {
            this.$nextTick(() => {
                const coinsIconRef = this.$refs.coinsIcon;
                const chipsIconRef = this.$refs.chipsIcon;
                const goldenTokenIconRef = this.$refs.goldenTokenIcon;

                if (!coinsIconRef || !chipsIconRef) return;

                const coinsIcon = coinsIconRef.getBoundingClientRect();
                const chipsIcon = chipsIconRef.getBoundingClientRect();
                // goldenTokenIcon 入口已下线，取不到时用 coins 图标的位置兜底，避免动画因缺少落点而中断
                const goldenTokenIcon = goldenTokenIconRef ? goldenTokenIconRef.getBoundingClientRect() : coinsIcon;

                this.to = {
                    coins: {
                        x: coinsIcon.left + (coinsIcon.width / 2),
                        y: coinsIcon.top + (coinsIcon.height / 2)
                    },
                    chips: {
                        x: chipsIcon.left + (chipsIcon.width / 2),
                        y: chipsIcon.top + (chipsIcon.height / 2)
                    },
                    golden_token: {
                        x: goldenTokenIcon.left + (goldenTokenIcon.width / 2),
                        y: goldenTokenIcon.top + (goldenTokenIcon.height / 2)
                    }
                }
            });
        },
        getPoTemplateKey(p, i) {
            return [
                p && p.type,
                p && (p.id || p.hash || p.name),
                p && p.layoutUrl,
                p && p.updated_at,
                i
            ].filter((v) => v !== undefined && v !== null && v !== "").join("|");
        },
        toggleMenuLogout() {
            this.showMenuLogout = !this.showMenuLogout;
        },
        closeInstallerStrip() {
            this.showInstallerStrip = false;
            this.isMobile && localStorage.setItem(INSTALLER_DISMISSED_KEY, '1');
        },
        showOpenAppPopup() {
            /*this.appPopup = true;
            this.$nextTick(() => {
                this.$refs.openApp && this.$refs.openApp.show && this.$refs.openApp.show();
            });*/

            window.vthis && window.vthis.wakeupApp && window.vthis.wakeupApp();
        },
        showInfoPopup() {
            this.$refs.infoPopup.show();
        },
        updateCoins(goldenToken, coins, chips){
            //console.log("lucky coin", goldenToken, coins, chips);
            this.user.golden_token = goldenToken;
            this.user.coins = coins;
            this.user.chips = chips;
        },
        showFooter(show){
            this.footerVisible = show;//!this.isMobile;
        },
        showLogoutTip() {
            this.$refs.logoutPopup.show()
        },
        logout() {
            this.$emit("logout")
        },
        wakeupApp() {
            utils.wakeupApp({
                onLikelyInstalled: () => {
                    if (this.isMobile) {
                        localStorage.setItem(APP_INSTALLED_HINT_KEY, '1');
                        this.showInstallerStrip = false;
                    }
                }
            });
        },
        collectFreeReward() {
            const po = this.poList && this.poList[this.poIndex];
            const nextProductIndex = this.pIndex + 1;
            const nextProduct = po && Array.isArray(po.products) && po.products[nextProductIndex];

            if (!nextProduct || !nextProduct.isFree || nextProduct.purchased) return;

            const items = nextProduct.items || {};
            this.pIndex = nextProductIndex;
            // claimed only when the user clicks collect, see claimFreeReward()
            this.pendingFreeProduct = { hash: nextProduct.hash, type: po.type };
            let isBlackWheel = items.blackwheel || nextProduct.blackwheel ? 1 : 0;
            const bonus = this.loyaltyExtra
            this.purchase = {
                isFree: true,
                type: po.type,
                coins: Math.round(Number((items.coins || nextProduct.coins || 0) * (1 + bonus.coins))),
                chips: Math.round(Number((items.chips || nextProduct.chips || 0) * (1 + bonus.chips))),
                bp: Number(nextProduct.bp || items.bp || 0),
                golden_token: Number(nextProduct.golden_tokens || items.golden_token || 0),
                is_wheel: isBlackWheel ? 0 : (items.wheel || nextProduct.wheel ? 1 : 0),
                is_black_wheel: isBlackWheel
            };
            this.updateAnimationTargets();
            this.$refs.collect.show();
        },
        claimFreeReward() {
            const pending = this.pendingFreeProduct;
            if (!pending || !pending.hash || !this.userID) return;

            this.pendingFreeProduct = null;

            api.saveFreePurchase(this.userID, pending.hash).then((resp) => {
                if (resp.data.status !== "ok") return;

                if (pending.type === "web_rolling_po") {
                    let po = this.$refs[pending.type];
                    po && po[0] && po[0].unlock && po[0].unlock();
                }

                this.refreshVipProgress();
            }).catch((error) => {
                console.error('Error claiming free reward:', error);
            });
        },
        buy(data) {
            if (!this.userID) return;

            this.poIndex = data.poIndex;
            this.pIndex = data.pIndex;
            this.pageLoad = false;

            // 购买之前更新用户数据
            api.guestLogin(this._global.sid, this.userID).then((loginResp) => {
                if (loginResp.data.status === "ok") {
                    let user = loginResp.data;
                    // 处理用户数据
                    this._global.user = {
                        userID: user.user_id,
                        coins: user.coins,
                        chips: user.chips,
                        golden_token: user.golden_token,
                        vip_bp: user.vip_bp,
                        vip_level: user.vip_level,
                        vip_next_level: user.vip_next_level,
                        vip_level_xp_required: user.vip_level_xp_required,
                        vip_level_xp_progress: user.vip_level_xp_progress,
                        username: user.name,
                        lang: user.lang,
                        avatar: user.pic
                    };
                    localStorage.setItem("userinfo", JSON.stringify(this._global.user));
                    //this._i18n.locale = /(en)|(es)|(pt)/.test(data.lang) ? data.lang : 'en';
                    this.user = this._global.user;
                    //console.log(data, loginResp.data);

                    if (data.free) {
                        api.saveFreePurchase(this.userID, data.hash).then((resp) => {
                            if (resp.data.status === "ok") {
                                let data = resp.data;
                                let isBlackWheel = typeof data.wheel !== 'undefined' && data.wheel.black_wedge_index && data.wheel.black_wedge_index.length > 0 ? 1: 0;
                                let purchase = {
                                    "isFree": true,
                                    "type": data.type,
                                    "coins": Number((data.coins || this.user.coins) - this.user.coins),
                                    "bp": Number((data.vip_bp || this.user.vip_bp) - this.user.vip_bp),
                                    "golden_token": Number((data.golden_token || this.user.golden_token) - this.user.golden_token),
                                    "chips": Number((data.chips || this.user.chips) - this.user.chips),
                                    "is_wheel": isBlackWheel ? 0 : (typeof data.wheel !== 'undefined' ? 1 : 0),
                                    "is_black_wheel": isBlackWheel
                                }

                                this.purchase = purchase;
                                this.updateAnimationTargets();
                                this.$refs.collect.show();

                                if (purchase.type === "web_rolling_po") {
                                    let po = this.$refs[purchase.type];
                                    po && po[0] && po[0].unlock && po[0].unlock();
                                }
                            }
                        })
                    } else {
                        api.getProductHash(this.userID, data.hash).then((resp) => {
                            if (resp.data.id) {
                                this.paymentId = resp.data.id;

                                this.$refs.payment.show();
                            }
                        })
                    }
                } else console.error('update user data failed!')
            })
        },
        openPaymentPage() {
            this.$refs.payment.hide();
            // Store payment window handle from Payment component
            this._paymentWindowHandle = this.$refs.payment.handle;
            
            // Monitor payment window closure
            this.monitorPaymentWindow();
            
            if (!this.isPending) {
                this.isPending = true;
                // Start pending check after a short delay to allow payment window to open
                setTimeout(() => {
                    this.pending();
                }, 500);
                
                // Set timeout for payment
                this.paymentTimeoutTimer = setTimeout(() => {
                    this.handlePaymentTimeout();
                }, this.paymentTimeout);
            }
        },
        monitorPaymentWindow() {
            // Clear any existing interval
            if (this.paymentCheckInterval) {
                clearInterval(this.paymentCheckInterval);
            }
            
            // Check if payment window is still open
            this.paymentCheckInterval = setInterval(() => {
                if (this._paymentWindowHandle && this._paymentWindowHandle.closed) {
                    clearInterval(this.paymentCheckInterval);
                    this.paymentCheckInterval = null;
                    this._paymentWindowHandle = null;
                    // Window closed, we'll wait for pending to complete or timeout
                }
            }, 1000);
        },
        handlePaymentTimeout() {
            // Payment timeout - no pending purchase found after max time
            if (this.paymentCheckInterval) {
                clearInterval(this.paymentCheckInterval);
                this.paymentCheckInterval = null;
            }
            this._paymentWindowHandle = null;
            
            this.isPending = false;
            this.$refs.paymentFailure.show(this.$t("message.paymentFailureReason"));
            
            // Reset all PO buttons
            this.onPaymentHide();
        },
        onPaymentFailureClose() {
            // Reset payment state
            this.isPending = false;
            this._paymentWindowHandle = null;
            this.onPaymentHide();
        },
        onPaymentHide() {
            this.poList && this.poList.map((po) => {
                po && po.type && this.$refs[po.type] && this.$refs[po.type][0] && this.$refs[po.type][0].resetButton && this.$refs[po.type][0].resetButton();
            })
        },
        buyFreeProductOnLoad() {
            this.$nextTick(() => {
                Object.keys(this.$refs || {}).forEach((refName) => {
                    const refs = Array.isArray(this.$refs[refName]) ? this.$refs[refName] : [this.$refs[refName]];
                    refs.forEach((ref) => {
                        ref && ref.buyFreeProductOnLoad && ref.buyFreeProductOnLoad();
                    });
                });
            });
        },
        showUserIDTutorialPopup() {
            let popup = this.$refs["userIDTutorial"];
            //console.log(this.$refs["userIDTutorial"])
            popup && popup.show();
        },
        pending(isOnce = false) {
            api.getPendingPurchase(this.userID).then((resp) => {
                if (resp.data.status === "ok" && resp.data.purchase_pending.length > 0) {
                    // Payment found - clear timeout
                    if (this.paymentTimeoutTimer) {
                        clearTimeout(this.paymentTimeoutTimer);
                        this.paymentTimeoutTimer = null;
                    }
                    
                    this.isPending = false;
                    this.regularReward = "NOT_COLLECTED";
                    const interval = setInterval(() => {
                        //console.log(this.regularReward);

                        if (this.poList.length > 0) {
                            clearInterval(interval); // stop checking

                            for (let i = 0; i < this.poList.length; i++) {
                                let products = this.poList[i].products;
                                //console.log(products, resp.data.purchase_pending);
                                for (let j = 0; j < products.length; j++) {
                                    let product = products[j];
                                    if (product['product_id'] == resp.data.purchase_pending[0].product_id) {
                                        this.poIndex = i;
                                        this.pIndex = j;
                                        break;
                                    }
                                }
                                if (this.poIndex != -1 && this.pIndex != -1) {
                                    break;
                                }
                            }
                            //console.log(this.poIndex, this.pIndex);
                        }
                    }, 500);
                    this.onPendingResult(resp, isOnce);
                } else {
                    this.regularReward = "COLLECTED";
                    this.buyFreeProductOnLoad();
                    !isOnce && (this.pendingTimer = setTimeout(this.pending.bind(this), 3000));
                }
            }).catch((error) => {
                console.error('Error checking pending purchase:', error);
                // Continue polling even on error
                this.regularReward = "COLLECTED";
                !isOnce && (this.pendingTimer = setTimeout(this.pending.bind(this), 3000));
            })
        },
        onPendingResult(resp, isOnce = false) {
            let purchase = {
                "pendingId": resp.data.purchase_pending[0].pending_id,
                "type": resp.data.purchase_pending[0].type
            };
            resp.data.purchase_pending[0].reward_items.map((i) => {
                if (i.type === "coins") purchase["coins"] = Number(i.data)
                else if (i.type === "chips") purchase["chips"] = Number(i.data)
                else if (i.type === "golden_token") purchase["golden_token"] = Number(i.data)
                else if (i.type === "vip_bp") purchase["bp"] = Number(i.data)
                else if (i.type === "loyalty") this.loyalty.loyalty_level = Number(i.data.loyalty_level)
                else if (i.type === "wheel_purchased") {
                    let product = i.data.products[0], wheel = product["items"].filter((i) => i.type === "wheel");
                    if (wheel && wheel.length > 0) {
                        wheel = wheel[0];
                        if (wheel["black_wedge_index"] && wheel["black_wedge_index"].length > 0) purchase["is_black_wheel"] = 1;
                        else purchase["is_wheel"] = 1;
                    }

                    //purchase["is_wheel"] = 1;
                }
            })

            this.purchase = purchase;
            this.updateAnimationTargets();
            this.$refs.collect.show();
            this.pendingTimer && clearTimeout(this.pendingTimer);

            if (!isOnce && (purchase.type === "web_rolling_po")) {
                let po = this.$refs[purchase.type];
                po && po[0] && po[0].unlock && po[0].unlock();
            }
        },
        collect(data) {
            api.collectPending(this.userID, data.pendingId).then((resp) => {
                if (resp.data.status === "ok") {
                    // singular
                    this.singular && singularSdk.revenue("onShopPurchaseComplete", resp.data.isoCurrencyCode, Number(resp.data.localizedPrice));

                    this.loyalty.loyalty_level = Number(resp.data.loyalty_level);

                    let items = resp.data.reward_items;
                    this.showTextAnimation({ "items": items });

                    this.$refs.collect.showBonusAnimation();
                    this.regularReward = "COLLECTED";
                    this.refreshVipProgress();
                }
            })
        },
        refreshVipProgress() {
            if (!this.userID) return;

            api.guestLogin(this._global.sid, this.userID).then((resp) => {
                if (resp.data.status !== "ok") return;

                const user = resp.data;
                const nextUser = {
                    ...(this.user || {}),
                    vip_bp: user.vip_bp,
                    vip_level: user.vip_level,
                    vip_next_level: user.vip_next_level,
                    vip_level_xp_required: user.vip_level_xp_required,
                    vip_level_xp_progress: user.vip_level_xp_progress
                };

                this.user = nextUser;
                this._global.user = {
                    ...(this._global.user || {}),
                    vip_bp: user.vip_bp,
                    vip_level: user.vip_level,
                    vip_next_level: user.vip_next_level,
                    vip_level_xp_required: user.vip_level_xp_required,
                    vip_level_xp_progress: user.vip_level_xp_progress
                };
                localStorage.setItem("userinfo", JSON.stringify(this._global.user));
            }).catch((error) => {
                console.error('Error refreshing VIP progress:', error);
            });
        },
        showRedeemPopup() {
            this.$refs.redeem.show();
        },
        handleAirdropCoins(coinsValue) {
            // console.log(coinsValue.data)
            const formattedCoins = utils.fc(coinsValue.data.coins);
            this.airdropCoins = formattedCoins;
        },
        handleBonusCollection(resp) {
            if (this._global.extra.bonus_type === 'manual') {
                const formattedCoins = utils.fc(resp.data.coins);
                this.airdropCoins = formattedCoins;
            }
            else if (this._global.extra.bonus_type === 'chips') {
                const formattedChips = utils.fc(resp.data.chips);
                this.bonusChips = formattedChips;
            }
        },
        showTextAnimation(data) {
            let items = data.items, user = JSON.parse(JSON.stringify(this.user));
            items.map((i) => {
                if (i.type === "coins") {
                    user && user.coins && (user.coins = Number(user.coins) + Number(i.data));

                    // coins text animation
                    utils.animation(3000, this.user.coins, user.coins, (_cur) => {
                        this.animationCoins = Math.round(_cur);
                    }, () => {
                        this.animationCoins = 0
                    })
                } else if (i.type === "chips") {
                    user && user.chips && (user.chips = Number(user.chips) + Number(i.data));

                    // chips text animation
                    utils.animation(3000, this.user.chips, user.chips, (_cur) => {
                        this.animationChips = Math.round(_cur);
                    }, () => {
                        this.animationChips = 0
                    })
                } else if (i.type === "golden_token") {
                    user && (user.golden_token = Number(user.golden_token) + Number(i.data));

                    // chips text animation
                    utils.animation(3000, this.user.golden_token, user.golden_token, (_cur) => {
                        this.animationToken = Math.round(_cur);
                    }, () => {
                        this.animationToken = 0
                    })
                }
            })
            this.user = user;
            localStorage.setItem("userinfo", JSON.stringify(this.user));
        },

        openPrizePage() {
            //console.log("claw product", this.clawProducts);
            if(!this.clawProducts.length){
                api.getClawProducts(this._global.sid).then((resp) => {
                    if (resp.data.status === "ok") {
                        //console.log(resp.data);
                        this.clawProducts = resp.data.products;
                    }
                })
            }
            this.showPrizePage = true;
        },

        closePrizePage() {
            this.showPrizePage = false;
        },
    },
    components: {
        Bonus,
        Logout,
        swiper,
        swiperSlide,
        prizes,
        bundles,
        claw,
        coins,
        chips,
        Collect,
        Payment,
        Award,
        OpenApp,
        Redeem,
        Scratch,
        DynamicPo,
        DynamicPoTemplate,
        FirstLogin,
        PaymentFailure,
        Info
    }
}
</script>

<style lang="scss">
@import "../assets/css/swiper.min.css";
@import "../assets/css/variables.scss";

#products-page {
    display: flex;
    flex-direction: column;
    background: url($assetRoot + "/desktop/web_pc_bg.png") center no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    height: 100%;

    .page-header {
        display: flex;
        align-items: center;
        width: 100%;
        /*padding: 0 20px 0 12px;
        min-height: 4.2vw;*/
        box-sizing: border-box;
        max-width: 1200px;
        margin: auto;
        position: relative;
        z-index: 0;
        height: 85px;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 50%;
            width: 100vw;
            transform: translateX(-50%);
            background: url($assetRoot + "/desktop/web_pc_tab_bg.png") center no-repeat;
            background-size: 100% 100%;
            z-index: -1;
            pointer-events: none;
        }

        > * {
            position: relative;
            z-index: 1;
        }

        .user-info {
            display: none;
            flex: 0 0 28rem;
            position: relative;

            img {
                width: 2.6rem;
                margin-left: 1rem;
                border-radius: 50%;
            }

            .username {
                width: 5rem;
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #fff;
            }

            .user-id-cont {
                position: absolute;
                left: 10rem;
                top: -0.2rem;
                width: 17rem;

                .user-id {
                    display: flex;
                    align-items: center;
                    gap: .4rem;

                    .userID {
                        padding: 0.2rem 1rem;
                        background: url($assetRoot + "/web_id_bg.png") center no-repeat;
                        background-size: 100% 100%;
                        color: #fff;
                        line-height: 1.4rem !important;
                    }

                    .btn {
                        width: 1.8rem;
                    }
                }

                .user-id-tip {
                    span {
                        color: #FFDB32;
                        font-weight: bold;
                        line-height: 14px !important;
                    }
                }
            }
        }

        .user-coins,
        .user-dinero,
        .user-lucky-coins {
            flex: 0 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 5px;
        }

        .coins,
        .dineros,
        .lucky-coins {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;

            height: 45px;
            padding: 0 10px 0 10px;

            background: url($assetRoot + "/common/header_price_bg.png") right no-repeat;
            background-size: 100% 100%;

            img {
                position: relative;
                width: auto;
                height: 25px;
                left: auto;
                top: auto;
                transform: none !important;
            }

            span {
                color: #FFF;
                white-space: nowrap;
                line-height: 1;
                font-size: 20px;
            }
        }

        .user-coins .coins span, .user-dinero .dineros span, .user-lucky-coins .lucky-coins span{
            padding-right: 10px;
        }

        .logout {
            display: none;
            flex: 0 0 9rem;
            text-align: right;

            .logout-btn {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: .3rem;

                width: 7rem;
                height: 2.1rem;

                background: url($assetRoot + "/logout_icon_bg.png") left repeat-x;
                background-size: 100% 100%;

                img {
                    width: 1rem;
                }

                span {
                    color: #FFF;
                }
            }
        }

        .header-logo {
            display: flex;
            flex: 0 0 auto;
            align-items: center;

            img {
                display: block;
                height: 75px;
                width: auto;
                /*margin: 0 0.7vw;*/
            }
        }

        .user-info-id {
            min-width: 0;
            display: flex;
            margin: 15px 10px 0 10px;

            .user-info-text {
                display: flex;
                flex-direction: column;
                color: #FFFFFF;

                span {
                    display: block;
                    white-space: nowrap;
                }

                span:first-child {
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                span:last-child {
                    font-weight: 700;
                    letter-spacing: 0;
                }

                .user-id {
                    font-size: 1.6rem;
                    color: #FFFFFF;
                }

                .check-it {
                    margin-top: 5px;
                    font-size: 1.2rem;
                    color: #FFFFFF;
                }
            }
        }

        .header-menu {
            display: flex;
            flex: 0 0 auto;
            align-items: center;
            cursor: pointer;
            margin: 0 0.4vw 0 auto;

            img {
                display: block;
                height: 45px;
                width: auto;
                margin: 0;
            }
        }
    }

    .page-content {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE/Edge */

        &::-webkit-scrollbar {
            display: none; /* Chrome/Safari */
        }

        .content {
            width: 1024px;
            margin: 0 auto;

            .banners {
                width: 100%;
                height: 100%;
                color: #FFF;
                border-radius: .8rem;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .claw-section {
                border-radius: .8rem;
                overflow: hidden;
            }

            .title {
                margin: .6rem 0;

                .title-icon {
                    transform: translate(0, .1rem);
                    -webkit-transform: translate(0, .1rem);
                }

                img {
                    height: 2rem;
                }

                .promition {
                    height: 2.6rem;
                }

                .arrow {
                    height: 1.5rem;
                }
            }

            .coins,
            .chips,
            .bundles {
                text-align: center;
            }

            .bundles {
                width: 100%;

                .bundle {
                    display: block;
                    width: 100%;

                    .art {
                        width: 100%;
                        max-width: none;
                        display: block;
                    }

                    .bundle-content {
                        padding: 0 6.65%;
                    }

                    .buy-now {
                        .buy-btn {
                            width: 22%;
                            min-width: 190px;
                            max-width: 266px;
                            margin-left: -11%;
                        }
                    }
                }
            }

            .coins,
            .chips {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 2.5rem 2vw;
            }

            .coins .coin,
            .chips .chip {
                display: block;
                width: calc((100% - 4vw) / 3);
                min-width: 280px;
                height: auto;
                aspect-ratio: 320 / 260;
                margin-top: 0;
                background-size: 100% 100%;
                position: relative;

                .permissions {

                    .loyalty {

                        .icon-loyalty {
                            width: 3rem;
                            height: auto;
                            transform: translate(-10%, -.4rem);
                            -webkit-transform: translate(-10%, -.4rem);
                        }

                        .loyalty-points {
                            top: 3%;
                            left: 25%;
                            display: inline-block;
                            color: #FFF;
                            transform: translate(-1.2rem, .5rem);
                            -webkit-transform: translate(-1.2rem, .5rem);
                            text-shadow: 0 2px #4d1daf, 0 -2px #4d1daf, -2px 0 #4d1daf, 2px 0 #4d1daf, 2px 2px #4d1daf, 2px -2px #4d1daf, -2px 2px #4d1daf, -2px -2px #4d1daf;
                            font-size: 1.5rem;
                        }
                    }
                }

                .rewards {

                    .coin-icon,
                    .chip-icon {
                        img {
                            width: 240px;
                            height: 120px;
                        }
                    }
                }

                .reward-inf {
                    position: absolute;
                    left: 0;
                    bottom: 10px;
                    width: 100%;

                    .coin-count {
                        span {
                            text-shadow: 0 1px #ffffff, 0 -1px #ffffff, -1px 0 #ffffff, 1px 0 #ffffff,1px 1px #ffffff, 1px -1px #ffffff, -1px 1px #ffffff, -1px -1px #ffffff;
                            color: #180d44;
                            font-size: 2rem;
                        }
                    }

                    .chip-count {
                        span {
                            text-shadow: 0 1px #ffffff, 0 -1px #ffffff, -1px 0 #ffffff, 1px 0 #ffffff,1px 1px #ffffff, 1px -1px #ffffff, -1px 1px #ffffff, -1px -1px #ffffff;
                            color: #09300c;
                            font-size: 2rem;
                        }
                    }

                    .price {
                        .price-btn {
                            width: 196px;
                            height: 68px;
                            line-height: 60px;
                            margin: 0 auto;
                            background: url($assetRoot + "/common/prize_btn.png") center no-repeat;
                            background-size: 100% 100%;

                            span {
                                color: #FFF;
                                text-shadow: 0 2px #4d1daf, 0 -2px #4d1daf, -2px 0 #4d1daf, 2px 0 #4d1daf, 2px 2px #4d1daf, 2px -2px #4d1daf, -2px 2px #4d1daf, -2px -2px #4d1daf;
                                font-size: 2rem;
                            }
                        }
                    }
                }
            }

            .coin:not(:nth-child(3n+1)),
            .chip:not(:nth-child(3n+1)) {
                margin-left: 0;
            }

            .coin:nth-child(n+4),
            .chip:nth-child(n+4) {
                margin-top: 0;
            }

            .empty {
                height: 2.5rem;
            }
        }

        .prize-content {
            height: 100%;
            width: 100%;
        }
    }

    .vip-section {
        display: flex;
        align-items: center;
        height: 50px;
        min-height: 50px;
        margin: 20px auto 10px;
        box-sizing: border-box;
        gap: 50px;
        max-width: 1200px;
        width: 100%;
        z-index: 0;

        .info-icon,
        .vip-bar,
        .vip-bp {
            height: 100%;
            min-width: 0;
        }

        .info-icon {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                display: block;
                width: auto;
                height: 100%;
            }
        }

        .vip-bar {
            flex: 1 1 0;
            margin-left: .5rem;
            position: relative;
            --vip-progress: 50%;
            display: flex;
            align-items: center;
            justify-content: center;

            .vip-bar-base,
            .vip-bar-loading {
                position: absolute;
                left: 50%;
                top: 43%;
                transform: translate(-50%, -35%);
                width: 92%;
                max-height: 100%;
                height: auto;
            }

            .vip-bar-loading {
                clip-path: inset(0 calc(100% - var(--vip-progress)) 0 0);
            }

            .vip-bar-text {
                position: absolute;
                left: 50%;
                top: 45%;
                transform: translate(-50%, -50%);
                color: #fff;
                line-height: 1;
                text-shadow: 0 1px #180d44, 0 -1px #180d44, -1px 0 #180d44, 1px 0 #180d44, 1px 1px #180d44, 1px -1px #180d44, -1px 1px #180d44, -1px -1px #180d44;
                font-size: 1.5rem;
                z-index: 2;
                pointer-events: none;
            }

            .vip-level-icon {
                position: absolute;
                width: auto;
                height: 120%;
                top: 50%;
                transform: translateY(-50%);
                z-index: 3;

                &.left { left: -1.5%; }
                &.right { right: -1.5%; }
            }
        }

        .vip-bp {
            flex: 0 0 auto;
            margin-left: 5rem;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            img {
                width: auto;
                max-height: 100%;
                height: auto;
                display: block;
            }

            img:first-child {
                position: absolute;
                left: -.55rem;
                top: 40%;
                transform: translateY(-50%);
                width: auto;
                height: 88%;
                max-height: none;
                z-index: 2;
                pointer-events: none;
            }

            img:last-child {
                position: relative;
                z-index: 1;
                max-height: 82%;
                padding-left: .55rem;
                box-sizing: border-box;
            }

            .vip-bp-text {
                position: absolute;
                left: 50%;
                top: 45%;
                transform: translate(-50%, -50%);
                z-index: 3;
                color: #fff;
                line-height: 1;
                text-shadow: 0 1px #180d44, 0 -1px #180d44, -1px 0 #180d44, 1px 0 #180d44, 1px 1px #180d44, 1px -1px #180d44, -1px 1px #180d44, -1px -1px #180d44;
                font-size: 1.5rem;
                pointer-events: none;
            }
        }

        .vip-logout {
            flex: 0 0 auto;
            margin-left: 2.2rem;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            cursor: pointer;

            img {
                width: 70%;
                max-height: 100%;
                height: auto;
                display: block;
            }
        }
    }

    .installer-strip {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: clamp(44px, 3.3vw, 72px);
        min-height: clamp(44px, 3.3vw, 72px);
        margin: 0.25vw auto 0;
        padding: 0 clamp(8px, 0.83vw, 16px);
        box-sizing: border-box;
        max-width: 1024px;
        width: 100%;
        background: #fff;
        border-radius: clamp(6px, 0.5vw, 10px);

        .installer-left {
            display: flex;
            align-items: center;
            min-width: 0;
        }

        .installer-close {
            width: auto;
            height: clamp(20px, 1vw, 34px);
            margin-right: 1vw;
            margin-left: 1vw;
            cursor: pointer;
        }

        .installer-logo {
            width: auto;
            height: clamp(30px, 2.5vw, 52px);
            margin-right: 0.6vw;
            background: #2f6bff;
            border-radius: clamp(4px, 0.35vw, 8px);
            padding: clamp(2px, 0.2vw, 6px);
            box-sizing: border-box;
        }

        .installer-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: clamp(1px, 0.08vw, 3px);
            overflow: hidden;
            max-width: 100%;

            .installer-text-line {
                color: #555555;
                font-size: clamp(12px, 0.85vw, 16px);
                line-height: 1.05;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .installer-right {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex: 0 0 auto;
            min-width: 0;
        }

        .installer-install {
            width: auto;
            height: clamp(26px, 2.1vw, 44px);
            cursor: pointer;
        }

        .installer-logout {
            width: auto;
            height: clamp(26px, 2.1vw, 44px);
            cursor: pointer;
        }
    }

    .page-footer {
        display: flex !important;
        align-items: center;
        gap: .5rem;
        padding: .3rem .9rem;
        box-sizing: border-box;
        background-color: #f6f3ff;

        > div {
            flex: 1 1 0 !important;
            width: 33.3333%;
            max-width: 33.3333%;
            min-width: 0;
        }

        .secure-payment,
        .footer-help,
        .user-info {
            flex: 1 1 0;
            min-width: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50%;
        }

        .secure-payment {
            gap: .25rem;

            .secure-payment-text {
                display: flex;
                flex-direction: column;
                line-height: 1.05;
                color: #1f2c52;

                span {
                    display: block;
                    font-weight: 700;
                    letter-spacing: .01rem;
                    white-space: nowrap;
                }

                .secure-100{
                    font-size: 1.6rem;
                    color: #4c3371;
                }

                .pix-payment{
                    margin-top: 5px;
                    font-size: 1.2rem;
                    color: #604883;
                }
            }
        }

        .footer-help {
            gap: .2rem;

            .footer-help-text {
                display: flex;
                flex-direction: column;
                line-height: 1.05;
                color: #1f2c52;

                span {
                    display: block;
                    white-space: nowrap;
                }

                span:first-child {
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                span:last-child {
                    font-weight: 700;
                    letter-spacing: 0;
                }

                .need-help{
                    font-size: 1.6rem;
                    color: #4c3371;
                }

                .support-email{
                    margin-top: 5px;
                    font-size: 1.2rem;
                    color: #604883;
                }
            }
        }

        .secure-payment .btn,
        .footer-help .btn {
            width: auto;
            max-height: 100%;
        }

        .user-info {
            position: relative;
            text-align: center;

            .user-info-text {
                display: flex;
                flex-direction: column;
                line-height: 1.05;
                color: #1f2c52;

                span {
                    display: block;
                    white-space: nowrap;
                }

                span:first-child {
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                span:last-child {
                    font-weight: 700;
                    letter-spacing: 0;
                }

                .user-id{
                    font-size: 1.6rem;
                    color: #4c3371;
                }

                .check-it{
                    margin-top: 5px;
                    font-size: 1.2rem;
                    color: #604883;
                }
            }

            .btn {
                width: 4rem;
                margin: 0 1rem;
            }

            .user-id-cont {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;

                div {
                    line-height: 0 !important;
                }

                .user-id {
                    height: 3rem;
                    padding: .5rem 0 0 0;

                    .userID {
                        padding: 0.4rem 1.5rem;
                        background: url($assetRoot + "/id_bg.png") center no-repeat;
                        background-size: 100% 100%;
                        line-height: 1.8rem !important;
                        color: #FFF;
                    }

                    .btn {
                        width: 3rem;
                    }
                }

                .user-id-tip {
                    color: #4064DF;

                    span {
                        display: inline-block;
                        max-width: 100%;
                        line-height: 1rem !important;
                    }
                }
            }
        }
    }

    .page-content{
        .page-footer{
            background: none;
            padding: 1.5rem 0;
            max-width: 1024px;
            width: 100%;
            margin: auto;
            gap: 3rem;

            .secure-payment {
                .secure-payment-text {
                    color: #FFFFFF;
                    line-height: unset;
                    text-align: justify;

                    .secure-100{
                        font-size: 1.5rem;
                        color: #FFFFFF;
                        font-weight: unset;
                        letter-spacing: unset;
                    }

                    .pix-payment{
                        font-size: 1rem;
                        color: #FFFFFF;
                        font-weight: unset;
                        letter-spacing: unset;
                    }
                }
            }

            .footer-help {
                .footer-help-text {
                    color: #FFFFFF;
                    line-height: unset;
                    text-align: justify;

                    .need-help{
                        font-size: 1.5rem;
                        color: #FFFFFF;
                        font-weight: unset;
                        letter-spacing: unset;
                    }

                    .support-email{
                        font-size: 1rem;
                        color: #FFFFFF;
                        font-weight: unset;
                        letter-spacing: unset;
                    }
                }
            }

            .user-info {
                .user-info-text {
                    color: #FFFFFF;
                    line-height: unset;
                    text-align: justify;

                    .user-id{
                        font-size: 1.5rem;
                        color: #FFFFFF;
                        font-weight: unset;
                        letter-spacing: unset;
                    }

                    .check-it{
                        font-size: 1rem;
                        color: #FFFFFF;
                        font-weight: unset;
                        letter-spacing: unset;
                    }
                }
            }

            .secure-payment .btn,
            .footer-help .btn {
                height: 50px;
            }
        }
    }
}

.mobile {

    #products-page {
        background: url($assetRoot + "/mobile/web_phone_bg.png") center no-repeat;
        background-size: 100% 100%;
        overflow-x: hidden;
        height: 100%;

        .installer-strip {
            height: 5rem;
            min-height: 5rem;
            margin-top: .4rem;
            margin-bottom: .4rem;
            padding: 0 .4rem;
            max-width: 100vw;
            border-radius: .55rem;

            .installer-left {
                flex: 1 1 0;
                min-width: 0;
            }

            .installer-logo {
                height: 2.8rem;
            }

            .installer-install {
                height: 3.5rem;
            }

            .installer-logout {
                height: 3.5rem;
            }

            .installer-logo {
                margin-right: .45rem;
                padding: .15rem;
                border-radius: .3rem;
            }

            .installer-close {
                margin-right: 2rem;
                margin-left: 1rem;
                height: 1.5rem;
            }

            .installer-text {
                max-width: 100%;

                .installer-text-line {
                    font-size: 1rem;
                    line-height: 1.05;
                }
            }

            @media (orientation: landscape) {
                height: 10vh;
                min-height: 10vh;
                padding: 0 .6rem;

                .installer-close {
                    height: 5.8vh;
                }

                .installer-logo {
                    height: 8vh;
                }

                .installer-install {
                    height: 7vh;
                }

                .installer-logout {
                    height: 7vh;
                }

                .installer-text {
                    .installer-text-line {
                        font-size: .8rem;
                    }
                }
            }
        }

        .page-header {
            min-height: 5rem;
            align-items: center;
            flex-wrap: nowrap;
            width: 100%;
            padding: 0;
            height: unset;

            &::before {
                background: url($assetRoot + "/mobile/web_phone_tab_bg.png") center no-repeat;
            }

            div {
                line-height: normal;
            }

            .user-info {
                display: none;
            }

            .logout {
                display: none;
            }

            .header-logo,
            .header-menu {
                flex: 0 0 auto;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin: 0 .4rem;
                padding: 0;
            }

            .header-logo img,
            .header-menu img {
                display: block;
                width: 3rem;
                height: auto;
                margin: 0;
            }

            .user-coins,
            .user-dinero,
            .user-lucky-coins {
                flex: 1 1 0;
                display: flex;
                justify-content: center;
                align-items: center;
                min-width: 0;
                padding: 0 .15rem;
            }

            .coins,
            .dineros,
            .lucky-coins {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: .5rem;

                background: url($assetRoot + "/common/header_price_bg.png") right no-repeat;
                background-size: contain;

                width: 100%;
                min-width: 0;
                max-width: 100%;

                height: 3.6rem;
                line-height: 3.4rem;
                padding: 0 2rem 0 1rem;

                img {
                    position: relative;
                    left: auto;
                    top: auto;
                    height: 2.5rem;
                    transform: none !important;
                }

                span {
                    font-size: .9rem;
                    line-height: 1;
                    white-space: nowrap;
                    transform: none;
                }

                @media (orientation: landscape) {
                    height: 10vh;
                    padding: 0 4% 0 1.5%;
                    background-size: 100% 100%;
                    line-height: normal;

                    img {
                        height: 7.5vh;
                    }

                    span {
                        font-size: 1rem;
                    }
                }
            }
        }

        .vip-section {
            height: 5rem;
            min-height: 5rem;
            margin-top: .4rem;
            margin-bottom: .4rem;
            padding: 0 .4rem;
            box-sizing: border-box;
            gap: .625rem;
            max-width: 100vw;

            .info-icon,
            .vip-bar,
            .vip-bp {
                height: 100%;
                min-width: 0;
            }

            .info-icon {
                flex: 10 1 0;
                max-width: none;
            }

            .vip-bar {
                flex: 58 1 0;
                max-width: none;
                margin-left: 1rem;
            }

            .vip-bp {
                flex: 30 1 0;
                max-width: none;
                margin-left: 1.5rem;
            }

            .vip-logout {
                flex: 30 1 0;
                max-width: none;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                cursor: pointer;

                img {
                    width: auto;
                    max-width: 100%;
                    max-height: 100%;
                    height: auto;
                }
            }

            .info-icon,
            .vip-bp {
                display: flex;
                align-items: center;
            }

            .info-icon {
                justify-content: center;

                img {
                    width: auto;
                    max-width: 100%;
                    max-height: 72%;
                    height: auto;
                }
            }

            .vip-bp {
                position: relative;
                justify-content: flex-end;

                img {
                    width: auto;
                    max-width: 100%;
                    max-height: 100%;
                    height: auto;
                }

                img:first-child {
                    position: absolute;
                    left: -.55rem;
                    top: 40%;
                    transform: translateY(-50%);
                    width: auto;
                    max-width: none;
                    height: 88%;
                    max-height: none;
                    z-index: 2;
                    pointer-events: none;
                }

                img:last-child {
                    position: relative;
                    z-index: 1;
                    max-height: 82%;
                    padding-left: .55rem;
                    box-sizing: border-box;
                }
            }

            .vip-bar {
                position: relative;
                --vip-progress: 50%;
                display: flex;
                align-items: center;
                justify-content: center;

                .vip-bar-base,
                .vip-bar-loading {
                    position: absolute;
                    left: 50%;
                    top: 43%;
                    transform: translate(-50%, -35%);
                    width: 92%;
                    max-height: 100%;
                    height: auto;
                }

                .vip-bar-loading {
                    clip-path: inset(0 calc(100% - var(--vip-progress)) 0 0);
                }

                .vip-level-icon {
                    position: absolute;
                    width: 12%;
                    height: auto;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 3;

                    &.left {
                        left: -3%;
                    }

                    &.right {
                        right: -3%;
                    }
                }
            }
        }

        .page-content {

            .content {
                width: auto;
                margin: 0 .4rem;

                .title {

                    img {
                        height: 3rem;
                    }

                    .promition {
                        height: 3.5rem;
                    }
                }

                .banners {
                    height: 28.32vw;
                    border-radius: .7rem;
                    overflow: hidden;
                }

                .claw-section {
                    border-radius: .7rem;
                    overflow: hidden;
                }

                .bundles {

                    .bundle {
                        height: 44vw;

                        .bundle-content {
                            padding: 0 7vw;

                            .permissions {
                                flex-basis: 16.7vw;

                                .loyalty {
                                    margin: 11vw 0 0 auto;
                                }

                                .extra {
                                    margin: 10vw 0 0 auto;
                                }
                            }

                            .rewards {

                                .reward-items {
                                    margin-top: 9vw;
                                    height: 26.4vw;

                                    .reward-item {
                                        width: calc(100% - 13vw);
                                        height: 7.3vw;
                                        line-height: 7.3vw;
                                        margin: 0 0 0 auto;
                                    }
                                }

                                .buy-now {
                                    height: 8vw;

                                    .buy-btn {
                                        width: 29vw;
                                        min-width: unset;
                                        max-width: unset;
                                        margin: 0 0 0 -15.6vw;
                                    }
                                }
                            }
                        }
                    }
                }

                .coins,
                .chips {
                    display: block;
                    gap: unset;
                    width: 100%;
                    margin: 0 auto;
                }

                .coins .coin,
                .chips .chip {
                    display: inline-block;
                    width: 45vw;
                    min-width: unset;
                    height: 36.5vw;
                    aspect-ratio: unset;

                    .permissions {

                        .loyalty {

                            .icon-loyalty {
                                width: 8vw;
                                transform: translate(-10%, -1vw);
                                -webkit-transform: translate(-10%, -1vw);
                            }

                            .loyalty-points {
                                left: 30%;
                                top:0;
                                font-size: 2rem;
                                transform: translate(-4vw, 2vw);
                                -webkit-transform: translate(-4vw, 2vw);
                            }
                        }
                    }

                    .rewards {
                        margin: 0;
                        top: 54%;

                        .reward-icon {
                            width: 100%;
                            padding: 0;

                            img {
                                width: 40vw;
                                height: 20vw;
                                transform: translate(0, -1rem);
                                -webkit-transform: translate(0, -1rem);
                            }
                        }
                    }

                    .reward-inf {
                        bottom: 0;

                        .reward-count {

                            span {
                                font-size: 2.6rem;
                            }
                        }
                    }

                    .price {

                        .price-btn {
                            width: 25vw;
                            height: 9vw;
                            line-height: 9vw;
                            margin-bottom: 5px;

                            span {
                                font-size: 2.4rem;
                            }
                        }
                    }
                }

                .coin:nth-child(even),
                .chip:nth-child(even) {
                    margin-left: 3vw;
                }

                .coin:nth-child(odd),
                .chip:nth-child(odd) {
                    margin-left: 0;
                }
            }

            .prize-content {
                height: 92vh;
            }
        }
    }

    #products-page .page-footer{
        padding: 0 3rem 0 1rem;
    }

    .page-footer {
        > div {
            flex: 1 1 0 !important;
            width: 33.3333%;
            max-width: 33.3333%;
            min-width: 0;
        }

        .secure-payment,
        .footer-help,
        .user-info {
            flex: 1 1 0;
            min-width: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50%;
        }

        .secure-payment {
            gap: .25rem;

            .secure-payment-text {
                display: flex;
                flex-direction: column;
                line-height: 1.05;
                color: #1f2c52;

                span {
                    display: block;
                    font-weight: 700;
                    letter-spacing: .01rem;
                    white-space: nowrap;
                }

                .secure-100{
                    font-size: 1.6rem;
                    color: #4c3371;
                }

                .pix-payment{
                    margin-top: 5px;
                    font-size: 1.2rem;
                    color: #604883;
                }
            }
        }

        .footer-help {
            gap: .2rem;

            .footer-help-text {
                display: flex;
                flex-direction: column;
                line-height: 1.05;
                color: #1f2c52;

                span {
                    display: block;
                    white-space: nowrap;
                }

                span:first-child {
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                span:last-child {
                    font-weight: 700;
                    letter-spacing: 0;
                }

                .need-help{
                    font-size: 1.6rem;
                    color: #4c3371;
                }

                .support-email{
                    margin-top: 5px;
                    font-size: 1.2rem;
                    color: #604883;
                }
            }
        }

        .secure-payment .btn,
        .footer-help .btn {
            width: auto;
            max-height: 100%;
        }

        .user-info {
            position: relative;
            text-align: center;

            .user-info-text {
                display: flex;
                flex-direction: column;
                line-height: 1.05;
                color: #1f2c52;

                span {
                    display: block;
                    white-space: nowrap;
                }

                span:first-child {
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                span:last-child {
                    font-weight: 700;
                    letter-spacing: 0;
                }

                .user-id{
                    font-size: 1.6rem;
                    color: #4c3371;
                }

                .check-it{
                    margin-top: 5px;
                    font-size: 1.2rem;
                    color: #604883;
                }
            }

            .btn {
                width: 4rem;
                margin: 0 1rem;
            }

            .user-id-cont {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;

                div {
                    line-height: 0 !important;
                }

                .user-id {
                    height: 3rem;
                    padding: .5rem 0 0 0;

                    .userID {
                        padding: 0.4rem 1.5rem;
                        background: url($assetRoot + "/id_bg.png") center no-repeat;
                        background-size: 100% 100%;
                        line-height: 1.8rem !important;
                        color: #FFF;
                    }

                    .btn {
                        width: 3rem;
                    }
                }

                .user-id-tip {
                    color: #4064DF;

                    span {
                        display: inline-block;
                        max-width: 100%;
                        line-height: 1rem !important;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductList.vue